import { Columns } from '@shared/interfaces/table/column-config';
import { MeteringPointDetails } from '@app/api/dmc';
import {TranslateCellComponent} from '@shared/components/table/cells/translate-cell/translate-cell.component';

export const meterDetailsMasterdata: Columns<MeteringPointDetails>[] = [
  {
    title: 'Målernummer',
    key: 'detailMeterCharacteristic.identification'
  },
  {
    title: 'Målercifre',
    key: 'detailMeterCharacteristic.numberOfDigits'
  },
  {
    title: 'Målerenhed',
    key: 'detailMeterCharacteristic.unitType'
  },
  {
    title: 'Målertype',
    key: 'detailMeterCharacteristic.meterReadingType',
    cellRenderer: TranslateCellComponent,
    cellRendererParams: {
      notspecified: 'enum.meteringpoint.meterreadingtype.notspecified',
      accumulated: 'enum.meteringpoint.meterreadingtype.accumulated',
      balanced: 'enum.meteringpoint.meterreadingtype.balanced',
      none: 'enum.meteringpoint.meterreadingtype.none'
    }
  }
];
